import {withClassNames} from 'quickstart/theme'
import S from './styles.module.css'

export const Flex = withClassNames(S.flex)('div')
